var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.setLayout,{tag:"components",attrs:{"config":_vm.setLayoutConfig},scopedSlots:_vm._u([{key:"sticky",fn:function(){return _vm._l((_vm.getStickyComponents),function(component,index){return _c(component.name,{key:index,tag:"components",attrs:{"config":component.config}})})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }